import React from 'react';
import { Redirect } from 'react-router-dom';

const HomePageComponent = React.memo(() => <Redirect to="/portfolio" />);

HomePageComponent.displayName = 'HomePageComponent';

export default HomePageComponent;
